import { render, staticRenderFns } from "./modalOrderCategories.vue?vue&type=template&id=206be346"
import script from "./modalOrderCategories.vue?vue&type=script&lang=js"
export * from "./modalOrderCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports